import React from 'react';

import {graphql, useStaticQuery} from 'gatsby';
import {GridCardSmall} from 'src/components/editorial/GridCardSmall';
import {ChiefLogo} from 'src/svgs/chiefLogo';

import {SanityEditorial} from 'types/generated';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type NextUpTrendingeProps = any;

export const NextUpTrending: React.FC<NextUpTrendingeProps> = (props: NextUpTrendingeProps) => {
  const data = useStaticQuery(graphql`
    query NextUpTrendingQuery {
      sanityArticleFooterTrending {
        _rawCta
        _rawArticles(resolveReferences: {maxDepth: 4})
        heading
        subCopy
        content
      }
      allSanityEditorial(sort: {fields: publishDate, order: DESC}, limit: 4) {
        nodes {
          title
          slug {
            current
          }
          heroImage {
            altText
            asset {
              id
              url
            }
          }
          isPodcast
          editorialCategory {
            title
            slug {
              current
            }
          }
        }
      }
    }
  `);

  const globalTrendingContent = data.sanityArticleFooterTrending;
  const defaultArticles = data.allSanityEditorial.nodes;
  const recentArticles =
    globalTrendingContent?._rawArticles ??
    defaultArticles.filter((article: SanityEditorial) => article?.slug?.current !== props.slug);

  const cta = (props.useDefaultNextUpTrending && globalTrendingContent) ?? globalTrendingContent._rawCta[0];
  return (
    <section className="px-gutter bg-ivory module-spacing" data-module="next-up-article-grid">
      <div className="wrapper-default grid grid-cols-4 md:grid-cols-12 lg:gap-8">
        <div className="col-span-full grid grid-cols-4 md:grid-cols-12 gap-8">
          <div className="col-span-full md:col-span-6 lg:col-span-5 bg-green-dark text-white px-12 py-16">
            <div className="fill-current mb-4 lg:mb-5">
              <ChiefLogo classes={'h-[18px] lg:w-25 lg:h-5 fill-white'} />
            </div>
            <h3 className="type-epsilon">
              {props.useDefaultNextUpTrending ? props.block?.heading : globalTrendingContent?.heading}{' '}
            </h3>
            <p className="type-theta mt-7">
              {props.useDefaultNextUpTrending ? props.block?.subCopy : globalTrendingContent?.subCopy}
            </p>
            <p className="type-sm-p mt-7">
              {props.useDefaultNextUpTrending ? props.block?.content : globalTrendingContent?.content}
            </p>
            <div className="mt-5 lg:mt-8">
              {cta && (
                <a href={cta.href} className="button" target={cta.target}>
                  {cta.buttonText}
                </a>
              )}
            </div>
          </div>

          <div className="col-span-full md:col-span-6 md:col-start-7">
            <h3 className="type-delta border-b w-full border-green-dark/30 md:border-none pb-4 md:p-0 mb-6 md:mb-8">
              Trending Now
            </h3>
            <div className="grid grid-cols-1 gap-y-6">
              <GridCardSmall article={props.useDefaultNextUpTrending ?? recentArticles[0]} />
              <GridCardSmall article={props.useDefaultNextUpTrending ?? recentArticles[1]} />
              <GridCardSmall article={props.useDefaultNextUpTrending ?? recentArticles[2]} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
